<template>
  <div :class="classes">
       <pt-page-title title="银行分期返惠详情"></pt-page-title>
       <pt-sub-title title="用户信息"></pt-sub-title>
         <template>
      <div :class="$style['pt-fast-laon-detail-customer']" v-loading="loading">
        <table>
          <!-- <pt-message-table-item label="闪贷返现流水号">{{flashBorrowDetail.serialNumber}}</pt-message-table-item> -->
          <pt-message-table-item label="客户姓名">{{flashBorrowDetail.cpsCustomerName}}</pt-message-table-item>
          <pt-message-table-item label="合同编号">{{flashBorrowDetail.contractNumber}}</pt-message-table-item>
          <pt-message-table-item label="生命银行用户">{{flashBorrowDetail.username}}</pt-message-table-item>
          <pt-message-table-item label="C端手机号">{{flashBorrowDetail.mobile}}</pt-message-table-item>
          <pt-message-table-item label="所在地">{{flashBorrowDetail.city}}</pt-message-table-item>
          <pt-message-table-item label="所属区域">{{flashBorrowDetail.address}}</pt-message-table-item>
        </table>
      </div>
       <pt-sub-title title="返现信息"></pt-sub-title>
         <div :class="$style['pt-fast-laon-detail-customer']">
        <table>
            <pt-message-table-item label="收款方账户名称">{{flashBorrowDetail.bankAccountName}}</pt-message-table-item>
          <pt-message-table-item label="身份证号">{{flashBorrowDetail.bankIdCard}}</pt-message-table-item>
          <pt-message-table-item label="银行预留手机号">{{flashBorrowDetail.bankMobile}}</pt-message-table-item>
          <pt-message-table-item label="开户银行">{{flashBorrowDetail.bankName}}</pt-message-table-item>
           <pt-message-table-item label="开户行全称">{{flashBorrowDetail.bankBranchName}}</pt-message-table-item>
          <pt-message-table-item label="收款账户">{{flashBorrowDetail.bankCardNumber}}</pt-message-table-item>
           <pt-message-table-item label="申请时间">{{flashBorrowDetail.apply_date}}</pt-message-table-item>
          <pt-message-table-item label="银行分期返惠凭证" v-if="flashBorrowDetail.bankFlashBorrowScreenshots">
              <img :class="$style['flash-borrow-img']" @click="onPreview(flashBorrowDetail.bankFlashBorrowScreenshots)" :src="privateResourcesUrl+flashBorrowDetail.bankFlashBorrowScreenshots"/>
          </pt-message-table-item>
          <pt-message-table-item label="返现金额">
               <wt-input v-if="flashBorrowDetail.status === 'WAITING_FOR_AUDIT'" v-model="cashBackAmount" placeholder="请输入返现金额" :class="$style['flash-borrow-amount']"  data-vv-as="返现金额" type="number" v-validate="'required|decimal:2|min_value:0'">
                <el-button slot="append">元</el-button>
              </wt-input>
              <template v-else>¥{{flashBorrowDetail.cash_back_amount}}</template>
          </pt-message-table-item>
        </table>
        <div  v-if="isAuditability" class="button-div">
            <el-button type="primary" @click="flashBorrowAudit" :loading="submitLoading" v-if="isShowCompleteButton">审核通过</el-button>
            <el-button type="primary" @click="completed" :loading="submitLoading" v-if="isShowGrantButton">发放</el-button>
        </div>
        </div>

    </template>
        <wt-image-preview v-if="previewVisible" @close-preview="closePreview" :value="images" :initial-index="currentIndex" :loop="false"></wt-image-preview>
  </div>
</template>

<script>
// 组件class前缀
import { cashCount } from '@/utils/formUtils'
import { hasPermissions } from 'utils/permissions'
import formMixins from 'mixins/form'
const prefixCls = 'pt-fast-loan-audit-detail'

const PERM_FLASH_COMPLETED = 'PERM_FLASH_COMPLETED'// 闪贷返现财务审核权限
const PERM_FLASH_BORROW = 'PERM_FLASH_BORROW'// 闪贷返现客服审核权限
export default {
  name: 'pt-fast-loan-audit-detail',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // 是否显示按钮
    isAuditability () {
      return this.flashBorrowDetail.status && (this.isShowCompleteButton || this.isShowGrantButton)
    },
    HAS_PERM_FLASH_COMPLETED () { // 闪贷返现财务审核权限（发放）
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_FLASH_COMPLETED)
    },
    HAS_PERM_FLASH_BORROW () { // 闪贷返现客服审核专员
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_FLASH_BORROW)
    },
    // 是否显示审核按钮
    isShowCompleteButton () {
      return this.flashBorrowDetail.status === 'WAITING_FOR_AUDIT' && this.HAS_PERM_FLASH_BORROW
    },
    // 是否显示发放按钮
    isShowGrantButton () {
      return this.flashBorrowDetail.status === 'WAITING_FOR_COMPLETE' && this.HAS_PERM_FLASH_COMPLETED
    }
  },
  props: {
    flashBorrowDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    id: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      privateResourcesUrl: this.$privateResourcesUrl,
      currentIndex: 1,
      images: null,
      previewVisible: false,
      cashBackAmount: 2200
    }
  },
  methods: {
    completed () {
      this.$confirm('确定完成该银行分期返惠提现吗？', '完成提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('flashBorrowCompleted', this.id)
      })
    },
    flashBorrowAudit () {
      let form = {
        cashBackAmount: cashCount(this.cashBackAmount),
        flashBorrowId: this.id
      }
      this.$emit('flashBorrowAudit', form)
    },
    onPreview (img) {
      this.images = this.privateResourcesUrl + img
      this.previewVisible = true
    },
    closePreview () {
      this.previewVisible = false
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import "~less/var";
.pt-fast-laon-detail-customer{
    padding: 0 20px;
    :global
    .pt-message-table-item{
        &>:first-child{

        line-height: 40px
        }
    }
}
.flash-borrow-img{
    max-width: 100px;
}
.flash-borrow-amount{
     max-width:300px;
  margin-right: 30px;
}
</style>
